import Switch from "react-switch";
import React, { Component, Fragment } from "react";
import { Card, Button, Table, Form } from "react-bootstrap";
import DepartmentModal from "./DepartmentModal";

class UserRoles extends Component {
  state = {
    isVisible: false,
    currentRoleId: -1,
    currentDepartments: []
  };

  closeModal = () => {
    this.setState({
      isVisible: false,
      currentRoleId: -1
    });
  };

  openModal = currentRoleId => {
    this.setState({
      isVisible: true,
      currentRoleId
    });
  };

  renderDepartments = role => {
    if (role) {
      if (role.departments !== undefined)
        return role.departments.map((dept, index) => (
          <span
            key={index}
            class={`badge ${
              this.props.defaultRole.departmentId === dept.id &&
              this.props.defaultRole.roleId === role.roleId
                ? "badge-success"
                : "badge-secondary"
            } p-2 m-2`}
          >
            {dept.Name}
          </span>
        ));
    }
    return null;
  };

  renderRows = () => {
    return this.props.roles.map((role, index) => {
      let isChecked = this.props.selectedRoles.find(
        currentRole => currentRole.roleId === role.id
      );
      return (
        <tr key={index}>
          <td style={{ width: "10%" }}>
            <div className="custom-control custom-switch">
              <Form.Group>
                <Switch
                  checked={isChecked}
                  onChange={() => {
                    if (isChecked) this.props.removeRole(role);
                    else this.props.addRole(role);
                  }}
                />
              </Form.Group>
            </div>
          </td>
          <td style={{ width: "20%" }}>{role.roleType}</td>
          <td style={{ width: "70%" }}>
            <div class="d-flex flex-row mb-3">
              <Button
                variant="outline-info"
                size="sm"
                style={{ height: "30px" }}
                onMouseUp={() => this.openModal(role.id)}
                disabled={!isChecked}
              >
                <i className="fa fa-plus" />
              </Button>
              <div className="flex-row flex-wrap justify-content-center ml-3">
                {this.renderDepartments(isChecked)}
              </div>
            </div>
          </td>
        </tr>
      );
    });
  };

  render() {
    return (
      <Fragment>
        <h3 className="mt-3">User Roles</h3>
        <Card>
          <Card.Header>User Roles</Card.Header>
          <Card.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Check</th>
                  <th>Role Type</th>
                  <th>For Departments</th>
                </tr>
              </thead>
              <tbody>{this.renderRows()}</tbody>
            </Table>
          </Card.Body>
        </Card>
        <DepartmentModal
          closeModal={this.closeModal}
          isVisible={this.state.isVisible}
          defaultRole={this.props.defaultRole}
          departments={this.props.departments}
          currentRole={this.state.currentRoleId}
          selectedRoles={this.props.selectedRoles}
          addDepartments={this.props.addDepartments}
          currentDepartments={this.state.currentDepartments}
        />
      </Fragment>
    );
  }
}

export default UserRoles;
